//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.3]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export enum CategoryLineOfBusinessEnum {
    All = 0,
    Travel = 1,
    Locums = 2,
    AccessControl = 3,
}